export enum BackgroundSizeOption {
  CONTAIN = 'contain',
  COVER = 'cover',
  AUTO = 'auto',
  FULL = 'full'
}
